// T2T-04 — Request List / Kanban / Calendar API wrappers

import { getData, postData, putData } from "../FetchApiServices";

const BASE = "t2t/requests";

export const fetchRequestList = (params = {}) => {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null))
  ).toString();
  return getData(`${BASE}/list${q ? `?${q}` : ""}`);
};

export const fetchRequestCounts = () => getData(`${BASE}/counts`);

export const fetchRequestQuickDetail = (requestId) =>
  getData(`${BASE}/${requestId}/quick-detail`);

export const fetchRequestCalendar = (params = {}) => {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ""))
  ).toString();
  return getData(`${BASE}/calendar${q ? `?${q}` : ""}`);
};

export const generateRequestAISummary = (requestId) =>
  postData(`${BASE}/${requestId}/ai-summary`, {});

export const exportRequestsUrl = (params = {}) => {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null))
  ).toString();
  return `${BASE}/export${q ? `?${q}` : ""}`;
};

export const fetchKanbanBoard = (workflowId, groupBy = 'stage') =>
  getData(`${BASE}/kanban?workflow_id=${workflowId}&group_by=${groupBy}`);

export const kanbanMoveCard = (requestId, body) =>
  postData(`${BASE}/${requestId}/kanban-move`, body);

export const updateRequestFormData = (requestId, body) =>
  putData(`${BASE}/${requestId}/form-data`, body);

export const approveKanbanCard = (requestId) =>
  postData(`${BASE}/${requestId}/action`, { action: "approve" });

export const rejectKanbanCard = (requestId, body) =>
  postData(`${BASE}/${requestId}/action`, { action: "reject", comment: body.comment });

// BUG-62: proper reject flow with return-stage selection (mirrors detail-page UX)
export const fetchRejectionTargets = (requestId) =>
  postData(`${BASE}/${requestId}/rejection-targets`, {});

export const rejectRequestWithTarget = (requestId, body) =>
  postData(`${BASE}/${requestId}/reject`, body);

export const holdKanbanCard = (requestId, body) =>
  postData(`${BASE}/${requestId}/hold`, body);
